import React, { useEffect } from 'react';
import Principal from "../Principal/Principal";
import Recorrido from "../Recorrido/Recorrido";
import Disponibilidad from "../Disponibilidad/Disponibilidad";
import Ubicacion from "../ubicacion/Ubicacion";
import Concepto from "../Concepto/Concepto";
import ConceptoVideo from "../ConceptoVideo/ConceptoVideo";
import Slider from "../Slider/Slider";
import CasasVelasurBanner from '../Banner/CasasVelasurBanner';
import { SwiperSlide } from "swiper/react";
import { animateScroll as scroll, scrollSpy, scroller } from 'react-scroll';
import { useNavigate, useLocation } from 'react-router-dom';
import RecorridoHome from '../RecorridoHome/RecorridoHome';
import './Home.scss';
import { useTranslation } from 'react-i18next';

const Home1 = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const actualUrl = useLocation();

  const scrollTarget = (target) => { 
    scroller.scrollTo(target, {smooth: true, duration: 700});
  };
  
  const scrollToPage =  (target) => {
    navigate(`/${target}`);
    scrollTarget(target.slice(1));
  };

  useEffect(()=>{
    scrollToPage(actualUrl.hash);
  },[]);

  return(
    <>
      <div>
        <Principal/>
        <CasasVelasurBanner/>
        <ConceptoVideo/>
        <RecorridoHome></RecorridoHome>
        {/* <div id="macroproyecto" className="slider-galeria">
            <Slider nav={false} pag={true}>
              <SwiperSlide>
                <img src="/assets/galeria/img-aereo1-velasur.jpg" alt="" />
              </SwiperSlide>
              <SwiperSlide>
                <img src="/assets/galeria/img-aereo2-velasur.jpg" alt="" />
              </SwiperSlide>
              <SwiperSlide>
                <img src="/assets/galeria/img-aereo3-velasur.jpg" alt="" />
              </SwiperSlide>
            </Slider>
          </div> */}
        <Concepto
          titulo1={t('home1.community')}
          titulo2={t('home1.residential')}
        >
          <p>
            {t('home1.description.part1')}
            <strong>VELASUR</strong> {t('home1.description.part2')}
          </p>
        </Concepto>
        <Disponibilidad/>
        <Ubicacion/>
      </div>
    </>
  );
}

export default Home1;
